import { createReducer, createNamespacer } from '../../commons/js/utils/reducer';

const initialState = {
    weldActivityStats: [],
    dupWeldActivityStats: [],
    dayInfos: [],
    updatedDayInfo: {},
    isLoading: false,
    daysCount: 0,
    sundaysCount: 0,
    weldInchesJournals: [],
    hourlyWeldInches: {},
    newHourlyWeldInches: {},
    dayInfoToggle: {},
    updatedGroupedStat: {},
    toggleWeldInches: false,
    leftRef: [],
    rightRef: [],
    leftClass:'',
    openEditpackage: false,
    packageId: null,
    fabricationPackages: [],
    ganttFocus: false,
    maxRequiredDate: "",
    minStartDate: '',
    facilityList: [],
    selectedFacility: "",
    clientsList: [],
    selectedClient: { value: null, label: '' },
    pageNumber: 1,
    isScheduler: false,
    totalPages: 0,
    reduxSearch: '',
    disableSaveButton: true,
    materialList: [],
    material: "",
}

const namespacers = {
    ganttChart: createNamespacer("GANTT_CHART"),
}

const reducer = createReducer(initialState, {
    [namespacers.ganttChart("SET_LOADING")]:(state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [namespacers.ganttChart("TOGGLE_EDIT_PACKAGE")]:(state, action) => {
        return {
            ...state,
            openEditpackage: action.payload.value,
            packageId: action.payload.packageId,
        }
    },
    [namespacers.ganttChart("SET_WELD_ACTIVITY_STATS")]:(state, action) => {
        return {
            ...state,
            weldActivityStats: action.payload.value,
        }
    },
    [namespacers.ganttChart("CLEAR_REDUX_SEARCH")]:(state, action) => {
        return {
            ...state,
            reduxSearch: action.payload.value,
        }
    },
    [namespacers.ganttChart("SET_DUP_WELD_ACTIVITY_STATS")]:(state, action) => {
        return {
            ...state,
            dupWeldActivityStats: action.payload.value,
        }
    },
    [namespacers.ganttChart("SET_WELD_INCHES_JOURNALS")]:(state, action) => {
        return {
            ...state,
            weldInchesJournals: action.payload.value,
        }
    },
    [namespacers.ganttChart("SET_HOURLY_WELD_INCHES")]:(state, action) => {
        return {
            ...state,
            hourlyWeldInches: action.payload.value,
        }
    },
    
    [namespacers.ganttChart("SET_NEW_HOURLY_WELD_INCHES")]:(state, action) => {
        return {
            ...state,
            newHourlyWeldInches: action.payload.value,
        }
    },
    [namespacers.ganttChart("TOGGLE_INCHES_EDIT")]:(state, action) => {
        return {
            ...state,
            toggleWeldInches: action.payload.value,
        }
    },
    [namespacers.ganttChart("SET_MIN_MAX_DATE")]:(state, action) => {
        return {
            ...state,
            minStartDate: action.payload.minStartDate,
            maxRequiredDate: action.payload.maxRequiredDate,
        }
    },
    
    [namespacers.ganttChart("CLEAR_AND_SET_DAY_INFO_TOGGLE")]:(state, action) => {
        return {
            ...state,
            dayInfoToggle: action.payload.value,
        }
    },


    [namespacers.ganttChart("SET_GANTT_FOCUS")]:(state, action) => {
        return {
            ...state,
            ganttFocus: action.payload.value,
        }
    },
    
    [namespacers.ganttChart("SET_LEFT_REF")]:(state, action) => {
        return {
            ...state,
            leftRef: [
                ...state.leftRef,
                action.payload.value
            ],
        }
    },
    [namespacers.ganttChart("SET_RIGHT_REF")]:(state, action) => {
        return {
            ...state,
            rightRef: [
                ...state.rightRef,
                action.payload.value
            ],
        }
    },
    [namespacers.ganttChart("SET_NEW_GROUPED_STAT")]:(state, action) => {
        let newGroupedStat = {}

        newGroupedStat[action.payload.id] = {
            ...state.updatedGroupedStat[action.payload.id],
            [action.payload.key] : action.payload.value,
        }

        return {
            ...state,
            updatedGroupedStat: { ...newGroupedStat },
        }

    },
    [namespacers.ganttChart("SET_UPDATED_DAY_INFO")]:(state, action) => {
        let newDayInfo = {}

        newDayInfo[action.payload.date] = {
            'working_hours': action.payload.workingHours,
            'is_working': action.payload.isWorking,
            'insufficient_welders': action.payload.isSufficientWeldersCheck,
        }

        return {
            ...state,
            updatedDayInfo: { ...newDayInfo },
        }

    },

    [namespacers.ganttChart("CLEAR_UPDATED_DAY_INFO")]:(state, action) => {
        return {
            ...state,
            updatedDayInfo: initialState.updatedDayInfo,
        }
    },
    [namespacers.ganttChart("CLEAR_GROUPED_STAT")]:(state, action) => {
        return {
            ...state,
            updatedGroupedStat: initialState.updatedGroupedStat,
        }
    },
    [namespacers.ganttChart("CLEAR_TOGGLE_INCHES")]:(state, action) => {
        return {
            ...state,
            newHourlyWeldInches: initialState.newHourlyWeldInches,
        }
    },

    [namespacers.ganttChart("SET_DAY_INFO_ERRORS")]:(state, action) => {
        let newDayInfo = {}

        newDayInfo[action.payload.date] = {
            ...state.updatedDayInfo[action.payload.date], 
            'working_hours': action.payload.workingHours,
            'errors': action.payload.value 
        }

        return {
            ...state,
            updatedDayInfo: { ...newDayInfo },
        }

    },
    [namespacers.ganttChart("SET_UPDATED_GROUPED_STAT_ERRORS")]:(state, action) => {
        let newGroupedStat = {}

        newGroupedStat[action.payload.id] = {
            ...state.updatedGroupedStat[action.payload.id], 
            'errors': {
                'factor': action.payload.factorError,
                'no_of_mens': action.payload.NoOfMensError,
                'required_date': action.payload.requiredDateError,
                'shop_position': action.payload.shopPositionError,
            } 
        }

        return {
            ...state,
            updatedGroupedStat: { ...newGroupedStat },
        }

    },
    [namespacers.ganttChart("SET_WELD_INCHES_ERRORS")]:(state, action) => {
        let newWeldInches = {}

        newWeldInches = {
            ...state.newHourlyWeldInches, 
            'errors': action.payload.value 
        }

        return {
            ...state,
            newHourlyWeldInches: { ...newWeldInches },
        }

    },
    [namespacers.ganttChart("SET_ACTIVE_FACILITITES")]: (state, action) => {
        return {
            ...state,
            facilityList: action.payload.facilities
        }
    },
    [namespacers.ganttChart("SET_ACTIVE_CLIENTS")]: (state, action) => {
        return {
            ...state,
            clientsList: action.payload.clients
        }
    },
    [namespacers.ganttChart("SET_SELECTED_FACILITY")]: (state, action) => {
        return {
            ...state,
            selectedFacility: action.payload.value
        }
    },
    [namespacers.ganttChart("SET_SELECTED_CLIENT")]: (state, action) => {
        return {
            ...state,
            selectedClient: action.payload
        }
    },
    [namespacers.ganttChart("ADD_NEW_WELD_ACTIVITY_STAT")]:(state, action) => {
        return {
            ...state,
            weldActivityStats: [
                ...state.weldActivityStats, 
                action.payload.value
            ],
        }
    },

    [namespacers.ganttChart("SET_NEW_WELD_INCHES_JOURNALS")]:(state, action) => {
        return {
            ...state,
            weldInchesJournals: [
                ...state.weldInchesJournals, 
                ...action.payload.value,
            ],
        }
    },
    [namespacers.ganttChart("SET_DAY_INFOS")]:(state, action) => {
        return {
            ...state,
            dayInfos: action.payload.value,
            daysCount: action.payload.daysCount,
            sundaysCount: action.payload.sundaysCount,
        }
    },
    
    [namespacers.ganttChart("SET_NEW_DAY_INFOS")]:(state, action) => {
        return {
            ...state,
            dayInfos: 
                    state.dayInfos.slice(0, action.payload.index)
                    .concat([{
                    ...state.dayInfos[action.payload.index],
                    ...action.payload.value,
                    }])
                    .concat(state.dayInfos.slice(action.payload.index + 1)),
        }
    },
    [namespacers.ganttChart("SET_FABRICATION_PACKAGES")]:(state, action) => {
        return {
            ...state,
            fabricationPackages: action.payload.value,
        }
    },
    [namespacers.ganttChart("SET_INFINITE_SCROLL_WELD_ACTIVITY_STATS")]:(state, action) => {
        return {
            ...state,
            weldActivityStats: [...state.weldActivityStats, ...action.payload.value],
        }
    },
    [namespacers.ganttChart("SET_PAGE_NUMBER")]:(state, action) => {
        return {
            ...state,
            pageNumber: action.payload.pageNumber,
        }
    },
    [namespacers.ganttChart("SET_TOTAL_PAGES")]:(state, action) => {
        return {
            ...state,
            totalPages: action.payload.totalPages,
        }
    },
    [namespacers.ganttChart("SET_IS_SCHEDULER")]:(state, action) => {
        return {
            ...state,
            isScheduler: action.payload.value,
        }
    },
    [namespacers.ganttChart("STORE_SEARCH_KEY")]:(state, action) => {
        return {
            ...state,
            reduxSearch: action.payload.value,
        }
    },
    // [namespacers.ganttChart("SET_DUP_INFINITE_SCROLL_WELD_ACTIVITY_STATS")]:(state, action) => {
    //     return {
    //         ...state,
    //         dupWeldActivityStats: [...state.dupWeldActivityStats, ...action.payload.value],
    //     }
    // },
    [namespacers.ganttChart("ENABLE_SAVE")]:(state, action) => {
        return {
            ...state,
            disableSaveButton: action.payload.value
        }
    },
    [namespacers.ganttChart("SET_MATERIALS_LIST")]:(state, action) => {
        return {
            ...state,
            materialList: action.payload.value,
        }
    },
    [namespacers.ganttChart("SET_SELECTED_MATERIAL")]:(state, action) => {
        return {
            ...state,
            material: action.payload.value,
        }
    },
});

export default reducer;
